import { TranslationObject } from '@ngx-translate/core';

const kk: TranslationObject = {
  kk: 'Қазақ',
  en: 'Ағылшын',
  app: {
    title: 'Іске қосар алдында қауіпсіздік техникасын тексеру',
    forms: {
      ok: 'Ok',
      cancel: 'Болдырмау',
      create: 'Жасау',
      continue: 'Жалғастыру',
      selectAll: 'Барлығын таңдау',
      save: 'Сақтау',
      labels: {
        businessUnit: 'Бизнес бөлімшесі',
        placeholderBusinessUnit: 'Бизнес-бірлікті таңдаңыз',
        organization: 'Ұйым',
        placeholderOrganization: 'Ұйымды таңдаңыз',
        user: 'Пайдаланушы',
        name: 'аты-жөні',
        description: 'Сипаттамасы',
        displayRichEditor: 'Құрылымды редактор көрсету',
        placeHolderDescription: 'Сипаттаманы енгізіңіз',
        placeHolderReviewType: 'Тексеру түрін таңдаңыз',
        mandatory: 'Міндетті',
        isActive: 'Белсенді',
      },
      categories: {
        placeholders: {
          categoryName: 'Санат атауы',
        },
      },
      unsavedChangesWarning:
        'Сақталмаған өзгерістер анықталды. Егер осы беттен шықсаңыз, жасалған өзгерістер жоғалады.<br>Жалғастырғыңыз келе ме?',
      validation: {
        required: '{{controlName}} міндетті',
        invalidEmail: 'Жарамды электрондық пошта мекенжайын енгізіңіз',
      },
    },
    warnings: {
      removeOwnAdminRights:
        'Сіз өзіңіздің әкімші құқықтарыңызды алып тастадыңыз. Дұрыс жұмыс істеуі үшін веб-бетті жаңартыңыз.',
      removeOwnAccess:
        'Сіз өзіңіздің қол жетімділігіңізді алып тастадыңыз. Дұрыс жұмыс істеуі үшін веб-бетті жаңартыңыз.',
    },
  },
  header: {
    support: 'Қолдау',
    userGuide: 'Пайдаланушы нұсқаулығы',
  },
  navigation: {
    pssrs: 'Тексерулер',
    projects: 'Жобалар',
    actionsItems: 'Іс-шаралар',
    administration: 'Басқару',
    hierarchyManagement: 'Иерархия басқару',
    businessUnits: 'Бизнес бөлімшелері',
    organizations: 'Ұйымдар',
    facilityHierarchy: 'Нысан иерархиясы',
    accessManagement: 'Қол жетімділікті басқару',
    organizationUsers: 'Пайдаланушылар',
    buAdmins: 'ББ пайдаланушы әкімдері',
    userGroups: 'Іс-шара пайдаланушы топтары',
    systemAdmins: 'Жүйе әкімдері',
    pssrConfiguration: 'PSSR конфигурациясы',
    templates: 'PSSR бақылау тізімдері',
    categories: 'Санаттар',
  },
  functionalReviewList: {
    title: 'Функционалдық тексеру',
    noFunctionalReview: 'Функционалдық тексеру жоқ',
    id: 'ID',
    code: 'Код',
    question: 'Сұрақ',
    answer: 'Жауап',
    comment: 'Пікір',
    updatedBy: 'Жаңартқан',
    updatedDate: 'Жаңарту күні',
    createNewFunctionalReview: 'Жаңа функционалдық тексеру жасау',
    reviewType: 'Тексеру түрі',
    addQuestion: 'Сұрақ қосу',
    description: 'Сипаттама',
    subSection: 'Ішкі бөлім',
    clearAnswer: 'Жауапты тазалау',
    deleteQuestion: 'Сұрақты жою',
    deleteQuestionTitle: 'Сұрақты жою',
    confirmDeleteQuestion:
      '<span>Бұл сұрақты жойғыңыз келе ме?</span><br><br><span><b>Сұрақ:</b> {{ description }}</span>',
    generateReport: 'Есеп жасау',
    completeReview: 'Тексеруді аяқтау',
    generateSuccessMessage: 'Есеп сәтті жасалды',
    reviewSuccessMessage: 'Функционалдық тексеру сәтті аяқталды',
  },
  admin: {
    sysAdminList: {
      title: 'Жүйе әкімдері',
      addSysAdmin: 'әкімші қосу',
      fullName: 'толық аты-жөні',
      disabled: 'өшірілген',
      email: 'электрондық пошта',
      dialogs: {
        removeAccessHeader: 'Растау',
        removeAccessMessage: '[{{fullName}}] үшін жүйе әкімшісі қол жетімділігін алып тастағыңыз келе ме?',
      },
    },
    businessUnitLists: {
      title: 'Бизнес бөлімшелері',
      addBusinessUnit: 'Бизнес бөлімшесін қосу',
      tableTitle: 'Бизнес бөлімшесі',
    },
    businessUnitCreate: {
      title: 'Бизнес бөлімшесін жасау',
    },
    businessUnitEdit: {
      title: 'Бизнес бөлімшесін өңдеу',
    },
    businessUnitForm: {
      sections: {
        supportInformation: {
          titleSupport: 'Қолдау ақпараты',
          name: 'Аты',
          businessUnitSupportInfo: 'Бизнес бөлімшесінің қолдау ақпараты',
          businessUnitSupportInfoDescription: 'Бұл ақпарат қолдау бетінде көрсетіледі',
          displayRichEditor: 'Құрылымды редакторды көрсету',
        },
        approvalForAccess: {
          titleApproval: 'Қол жетімділікке рұқсат',
          userNeedsBuAdmin: 'Пайдаланушыға қол жетімділік беру үшін ББ әкімші қажет',
          userGetsInstantAccess: 'Пайдаланушы бірден қол жетімділік алады',
        },
        labels: {
          titleLabels: 'Белгілер',
          hierarchyLabel1: 'Иерархия белгісі 1',
          hierarchyLabel2: 'Иерархия белгісі 2',
          hierarchyLabel3: 'Иерархия белгісі 3',
          pssrLabel: 'PSSR белгісі',
          organizationLabel: 'Ұйым белгісі',
          eventNameLabel: 'Оқиға атауы белгісі',
          p3: 'P3',
          p4: 'P4',
          p5: 'P5',
          placeholderDefault: 'әдепкі мән - \'жоба\'',
          show: 'көрсету',
        },
        pssrConfigurations: {
          titleConfigurations: 'PSSR конфигурациялары',
          stagnantPssrInterval: 'Тұрақсыз PSSR интервалы',
          instructions: 'Нұсқаулар',
          instructionsDescription: 'PSSR үшін жалпы нұсқаулар',
          showProject: 'Жобаны көрсеткіңіз келе ме?',
          projectDisplayType: 'Жобаны қалай көрсеткіңіз келеді?',
          dropdown: 'Ашылмалы тізім',
          input: 'Енгізу',
          showKms: 'KMS-ті көрсеткіңіз келе ме? Жаңа PSSR жасау кезінде "KMS-тен алу" батырмасы пайда болады.',
          showQaqcModule: 'Жобада QAQC модулін көрсеткіңіз келе ме? Жобаны қосу қажет.',
          showWetSignatureApproval:
            'PSSR дымқыл қолтаңбасына рұқсат бергіңіз келе ме? Бұл операциялар өкіліне күтілетін мақұлдау мәртебесінде PSSR-ді мақұлдауға мүмкіндік береді. Батырма "дымқыл қолтаңбамен мақұлдау" деп аталады.',
          pssrTypesToShow: 'Қандай PSSR түрлерін көрсеткіңіз келеді?',
          ccc: 'CCC',
          factory: 'Зауыт',
          moc: 'MOC',
          nonMoc: 'MOC ЕМЕС',
          orr: 'ORR',
          pfsr: 'PFSR',
          test: 'Сынақ',
          showNaResponse:
            'Пайдаланушыларға N/A жауап беруге рұқсат бергіңіз келе ме? Жоқ деп таңдасаңыз, орындалды деп есептелу үшін пікір немесе іс-шара элементі қажет болады.',
          sendScheduledEmail:
            'Күтіліп тұрған іс-шара элементтері бар пайдаланушыларға әр дүйсенбі сағат 8:00 CST-де жоспарланған электрондық пошта жібергіңіз келе ме?',
          showConstructionComplete:
            'Кейбір тақырыптар/тітулдар/белгілер үшін Құрылысты аяқтау сертификатын (CCC) көрсеткіңіз келе ме?',
          showOperationReadiness:
            'Кейбір тақырыптар/тітулдар/белгілер үшін Операциялық дайындықты тексеруді (ORR) көрсеткіңіз келе ме?',
          showVerbalApproval:
            'Ауызша мақұлдауды көрсеткіңіз келе ме? Бұл мобильді қолданбада кім мақұлдайтынын қолмен жазу үшін енгізу жолын көрсетеді. Бұл ешқандай іс-қимыл тудырмайды және топ жетекшісі немесе мақұлдаушы орындай алады.',
          allowLeadToDelete:
            'Топ жетекшісіне жобалама немесе бастамаланған мәртебесіндегі PSSR сұрақтарын жоюға рұқсат бергіңіз келе ме?',
          allowTeamMemberActions:
            'Кез келген топ мүшесіне мақұлданғанға дейін сұрақтарға жауап беруге, сұрақтарға қол қоюға және іс-шара элементтерін жасауға рұқсат бергіңіз келе ме?',
          restrictMocWo: 'MOCWO жоба нөмірін шектегіңіз келе ме? "Иә" таңдасаңыз, PSSR жасау үшін MOC және WO қажет.',
          allowLeadsToShare:
            'Топ жетекшілеріне құрылғыны мақұлдаушылармен бөлісуге рұқсат бергіңіз келе ме? "Иә" таңдасаңыз, мақұлдаушы қол қоюға қатысса, жетекші құрылғыны бөліседі.',
          requireFinalApprovalBeforeInitiation:
            'Бастамалар алдында соңғы мақұлдауды талап еткіңіз келе ме? "Иә" болса, PSSR-ді бастамалау үшін соңғы мақұлдаушы болуы қажет.',
          allowFinalApproverNotifications: 'Соңғы мақұлдаушыға барлық хабарландыруларды алуға рұқсат бергіңіз келе ме?',
          allowFinalApproverSubmit: 'Соңғы мақұлдаушыға мақұлдауға жіберуге рұқсат бергіңіз келе ме?',
          allowMultiplesApprovers: 'Бірнеше мақұлдаушыға рұқсат бергіңіз келе ме?',
          ShowSectionsCollapsed: 'Өңдеу кезінде PSSR бөлімдерін жиюды қалайсыз ба?',
          requireActionItemDueDate: 'Іс-шара элементтері үшін мерзімді талап еткіңіз келе ме?',
          limitAccessToAIOwner:
            'Іс-шара элементінің иесі немесе тапсырылған адамның сипаттаманы өзгертуін, мерзімді өзгертуін немесе іс-шара элементін жоюын шектегіңіз келе ме?',
        },
        actionItemConfigurations: {
          titleItemConfigurations: 'Іс-шара элементі конфигурациялары',
          sendToMoc: 'Іс-шара элементтерін MOC-қа жібергіңіз келе ме?',
          p3: 'P3',
          p4: 'P4',
          allowTeamLeadAttach:
            'Топ жетекшісіне іс-шара элементін тіркеуге және өзгертуге рұқсат бергіңіз келе ме? "Иә" таңдасаңыз, жетекшілер күтілетін мақұлдаудан кейін тек файлдар, тапсырылған адам, мәртебе және пікір тіркей алады.',
          allowActionItemOwnerAttach:
            'Іс-шара элементінің иесіне PSSR жабылмаған кезде кез келген мәртебеде тіркеуге рұқсат бергіңіз келе ме?',
        },
      },
    },
  },
  user: {
    requestAccess: {
      title: 'Тіркелмеген',
      forms: {
        submit: 'Қол жетімділік сұрау',
      },
      dialogTitle: 'Қол жетімділік сұрау',
      dialogSubtitle: '<strong>{{Name}}</strong> үшін қол жетімділік сұраймын, жалғастырғыңыз келе ме?',
      reloadWarning:
        'Егер осы бетті кіргенде, бірақ қол жетімділігіңіз болса, қайта жүктеу үшін келесі сілтемені басыңыз, әйтпесе қолдауға хабарласыңыз.',
      reload: 'қайта жүктеу',
    },
    pendingAccess: {
      title: 'Сәлем, сіздің қол жетімділік сұрауыңыз орындалуда',
      reloadWarning:
        'Егер осы бетті кіргенде, бірақ қол жетімділігіңіз болса, қайта жүктеу үшін келесі сілтемені басыңыз, әйтпесе қолдауға хабарласыңыз.',
      reload: 'қайта жүктеу',
    },
  },
  footer: {
    text: 'Chevron Corporation. Барлық құқықтар қорғалған.',
  },
  checklist: {
    title: 'PSSR бақылау тізімі',
    create: 'жаңа жасау',
    hideCode: 'кодты жасыру',
    code: 'Код',
    name: 'Бақылау тізімінің атауы',
    edit: 'өңдеу',
    manage: 'басқару',
    delete: 'жою',
    noChecklists: 'Бақылау тізімдері жоқ.',
    defaultWalkthroughDisclaimer: 'Бастапқы аралау қолтаңбасының ескертуі',
    defaultSummaryDisclaimer: 'Бастапқы қорытынды қолтаңбасының ескертуі',
    displayRichEditor: 'бай редакторды көрсету',
    sampleText: 'үлгі мәтін',
    dialogs: {
      removeAccessHeader: 'Растау',
      removeAccessMessage: '[{{description}}] жойғыңыз келе ме?',
    },
    titleCreate: 'Бақылау тізімін жасау',
    createNew: 'Жаңа жасау',
    selectPlaceholder: 'Біреуін таңдаңыз...',
    titleEdit: 'Бақылау тізімін өңдеу',
    titleDelete: 'Бақылау тізімін жою',
    deletedSuccessfully: 'Бақылау тізімі сәтті жойылды',
    importChecklist: 'Бақылау тізімін импорттау',
    importChecklistTitle: 'Бақылау тізімін импорттау',
    selectChecklistType: 'Бақылау тізімінің түрін таңдаңыз',
    confirm: 'Растау',
    importSuccessMessage: 'Бақылау тізімі сәтті импортталды',
    emptyHierarchyChildrenMessage:
      '<p>Бұл <strong>{{parentLabel}}</strong> үшін <strong>{{childLabel}}</strong> жоқ.</p><p>Бастау үшін жаңа <strong>{{childLabel}}</strong> қосыңыз.</p>',
    confirmDelete:
      '<span>Бұл бақылау тізімін жойғыңыз келе ме?</span><br><br><span>Код: {{ name }}<br>Сипаттама: {{ description }}</span>',
  },
  checklistManage: {
    title: '[{{ description }}] басқару',
    sectionsTitle: 'Бөлімдер',
    addSectionAction: 'бөлім қосу',
    mandatoryLabel: 'Міндетті',
    createNewSubsectionAction: 'жаңа ішкі бөлім жасау',
    emptySubSectionsMessage: '<p>Бұл бөлімде мазмұн жоқ.</p><p>Бастау үшін ішкі бөлім қосыңыз.</p>',
    itemCodeTableHeader: 'код',
    itemDescriptionTableHeader: 'сипаттама',
    createNewItemAction: 'жаңа элемент жасау',
    createSectionHeader: 'Бөлім жасау',
    editSectionHeader: 'Бөлімді өңдеу',
    confirmDeleteSection: '<strong>{{description}}</strong> бөлімін жойғыңыз келе ме?',
    createSubSectionHeader: 'Ішкі бөлім жасау',
    editSubSectionHeader: 'Ішкі бөлімді өңдеу',
    createChecklistItemTitle: 'Бақылау тізімі элементін жасау',
    editChecklistItemTitle: 'Бақылау тізімі элементін өңдеу',
    ShouldAddCommentToQuestion: 'Пайдаланушы N/A деп жауап берген кез келген сұраққа пікір қосуы керек',
    autoGenerateCodeLabel: 'Кодты автоматты жасау',
    autoGenerateCodeplaceholder: 'Код автоматты жасалады',
    autoGenerateCodeInfo: 'Автоматты жасау іске қосылды, өріс автоматты толтырылады.',
    deleteChecklistItemTitle: 'Бақылау тізімі элементін жою',
    confirmDeleteChecklistItem:
      '<span>Бұл бақылау тізімі элементін жойғыңыз келе ме?</span><br><br><span><b>Код:</b> {{ name }}<br><b>Сипаттама:</b> {{ description }}</span>',
    confirmDeleteSubSection: '<strong>{{description}}</strong> ішкі бөлімін жойғыңыз келе ме?',
    deleteSectionHeader: 'Бөлімді жою',
    deleteSubSectionHeader: 'Ішкі бөлімді жою',
    editQuestionTitle: 'Сұрақты өңдеу',
    sectionTypeLabel: 'Бөлім түрі',
    sectionTypePlaceholder: 'Бөлім түрін таңдаңыз',
    subSectionNameLabel: 'Ішкі бөлім атауы',
    itemTypeLabel: 'Түр',
    itemTypePlaceholder: 'біреуін таңдаңыз',
    codePlaceholder: 'Код енгізіңіз',
    duplicateCodeError: 'Бұл код басқа бөлімде қолданылған.',
    displayRichEditorLabel: 'Бай редакторды көрсету',
    requireCommentForNA: 'N/A сұрағы үшін пікірді талап еткіңіз келе ме?',
    addQuestion: 'Сұрақ қосу',
    codeHeader: 'Код',
    descriptionHeader: 'Сипаттама',
  },
  common: {
    yes: 'Иә',
    no: 'Жоқ',
    na: 'Қолданылмайды',
    save: 'Сақтау',
    saving: 'Сақталуда...',
    businessUnit: 'Бизнес бөлімшесі',
    name: 'Аты',
    code: 'Код',
    cancel: 'Болдырмау',
    confirm: 'Растау',
    back: 'Артқа',
    forbidActionErrorMessage: 'Пайдаланушы бұл іс-қимылды орындауға өкілетті емес',
    genericErrorMessage: 'Күтпеген қате пайда болды. Кейінірек қайталап көріңіз.',
    errorOccurred: 'Қате пайда болды. Қайталап көріңіз.',
    savedSuccessfully: 'Сәтті сақталды',
    delete: 'Жою',
    deletedSuccessfully: 'Сәтті жойылды',
    edit: 'Өңдеу',
    leaveWithOutSaving: 'Сақтамай шығу',
    language: 'Тіл',
    month: 'Ай',
    months: 'Айлар',
    loading: 'Жүктелуде...',
    all: 'Барлығы',
    recordAlreadyExists: 'Енгізілген жазба бар',
    recordCreatedSuccessfully: 'Жазба сәтті жасалды',
    createdSuccessfully: 'Сәтті құрылды',
  },
  paginator: {
    previous: 'Алдыңғы',
    next: 'Келесі',
    currentPageReport: '{{currentInitialRow}} - {{currentLastRow}} / {{totalRecords}}',
  },
  usersList: {
    title: 'Пайдаланушылар',
    forms: {
      displayInactiveUsers: 'белсенді емес пайдаланушыларды көрсету',
      search: 'Іздеу',
    },
    actions: {
      addNewUser: 'Жаңа пайдаланушы қосу',
      grantAccess: 'қол жетімділік беру',
      reimportAllSharedUsers: 'Барлық ортақ пайдаланушыларды қайта импорттау',
    },
    table: {
      fullName: 'толық аты-жөні',
      email: 'электрондық пошта',
      admin: 'әкімші',
      type: 'түр',
    },
    noUsers: 'Пайдаланушылар жоқ',
    dialogs: {
      removeAccessHeader: 'Растау',
      removeAccessMessage: '[{{fullName}}] үшін қол жетімділікті алып тастағыңыз келе ме?',
      addUserHeader: 'Жаңа пайдаланушы қосу',
      editUserHeader: 'Пайдаланушыны өңдеу',
      reimportSharedUsersHeader: 'Барлық ортақ пайдаланушыларды қайта импорттау',
      reimportSharedUsersMessage:
        'Барлық ортақ пайдаланушы конфигурацияларын жаңартмақшысыз.<br> Бұл операция бірнеше минут уақыт алуы мүмкін.',
    },
    messages: {
      importSharedUsersFailed: 'Импорт сәтсіз аяқталды',
      importSharedUsersIncompleted: 'Импорт аяқталмады',
      importSharedUsersCompleted: 'Импорт аяқталды: {{ minutes }} мин',
      pleaseWaitUntilProcessEnds: 'Импорт процесі аяқталғанша күтіңіз. Осы беттен шықпаңыз немесе жаппаңыз.',
      importInProgress: 'Импорт жүріп жатыр. Бетті жабар алдында аяқталуын күтіңіз.',
      calculatingProgress: 'Прогресс есептелуде...',
    },
    labels: {
      imported: 'Импортталған',
      notFound: 'Табылмады',
      errors: 'Қателер',
      total: 'Жалпы',
    },
  },
  comments: {
    title: 'Пікірлер',
    addComment: 'пікір қосу',
    dialogs: {
      configureComment: 'Пікір',
      deleteCommentHeader: 'Пікірді жою',
      deleteCommentMessage: 'Бұл іс-қимылды орындағыңыз келе ме?',
    },
    comment: 'Пікір',
  },
  actionItems: {
    title: 'Іс-шара элементтері',
    id: 'ID',
    addActionItem: 'Іс-шара элементін қосу',
    noActionItems: 'Іс-шара элементтері жоқ',
    canOnlyPerformAttachments:
      'Тек файл тіркемелерін басқара аласыз. Іс-шара элементінің басқа қасиеттерін өңдеу мүмкін емес.',
    actionTitle: 'Тақырып',
    assignee: 'Тапсырылған адам',
    date: 'Күн',
    dueDate: 'Мерзімі',
    category: 'Санат',
    primaryCategory: 'Негізгі санат',
    secondaryCategory: 'Қосымша санат',
    subcategory: 'Ішкі санат',
    comment: 'Пікір',
    editComment: 'Пікірді өңдеу',
    commentRequiredWhenClosed: 'Мәртебе "Жабылған" болғанда пікір міндетті',
    priority: 'Басымдық',
    assignTo: 'Тапсыру',
    pssrCccMembers: '{{pssrTitle}} мүшелері',
    chevronDirectory: 'Chevron анықтамалығы',
    userGroup: 'Пайдаланушы тобы',
    other: 'Басқа',
    status: 'Мәртебе',
    statusNames: {
      Open: 'Ашық',
      Closed: 'Жабылған',
      Cancel: 'Болдырылмаған',
      Rejected: 'Қабылданбаған',
    },
    createdBy: 'Жасаған',
    updatedDate: 'Жаңарту күні',
    updatedBy: 'Жаңартқан',
    selectOne: 'Біреуін таңдаңыз...',
    typeNameOrEmail: 'Аты немесе email теріңіз...',
    inactive: 'Белсенді емес',
    reopen: 'Қайта ашу',
    reject: 'Қабылдамау',
    rejectReason: 'Қабылдамау себебі',
    rejectReasonPlaceholder: 'Қабылдамау себебін енгізіңіз',
    timeCaptured: 'Тіркелген уақыт',
    attachments: 'Тіркемелер',
    pssrFiles: 'PSSR файлдары',
    links: 'Сілтемелер',
    fileUpload: 'Файл жүктеу',
    attachFiles: 'Тіркеу (құжаттар, суреттер, т.б.)',
    fileTooLarge: '\'{{name}}\' файлы рұқсат етілген максималдан {{max}} асып кетті.',
    invalidFileFormat: '\'{{name}}\' файлының форматы қолдауға алынбаған.',
    duplicateFile: '\'{{name}}\' файлы бұрыннан қосылған.',
    linkPlaceholder: 'www.example.com',
    dialogs: {
      configureActionItem: 'Іс-шара элементін конфигурациялау',
      configureComment: 'Пікір',
      deleteActionItemHeader: 'Іс-шара элементін жою',
      deleteActionItemMessage: 'Бұл іс-қимылды орындағыңыз келе ме?',
      rejectActionItemHeader: 'Іс-шара элементін қабылдамау',
      confirmPriorityChangeHeader: 'Басымдық өзгерісін растау',
      confirmPriorityChangeMessage: 'Бұл іс-шара элементінің басымдығын өзгерткіңіз келе ме?',
      deleteAttachmentHeader: 'Тіркемені жою',
      deleteAttachmentMessage: 'Бұл тіркемені жойғыңыз келе ме?',
    },
    messages: {
      deleteSuccess: 'Іс-шара элементі сәтті жойылды',
      reopenSuccess: 'Іс-шара элементі сәтті қайта ашылды',
      rejectSuccess: 'Іс-шара элементі сәтті қабылданбады',
      rejectReasonRequired: 'Қабылдамау себебі міндетті',
      confirmReject: 'Бұл іс-шара элементін қабылдамағыңыз келе ме? Ол {{action}}.',
      confirmRejectP4: 'Бұл іс-шара элементін қабылдамағыңыз келе ме?',
      returnToTeamLead: 'топ жетекшісіне қайтарылады',
      confirmReopen: 'Бұл іс-шара элементін қайта ашқыңыз келе ме?',
    },
  },
  actionItemsList: {
    title: 'Іс-шара элементтері',
    sections: {
      location: 'Орын',
      pssr: 'PSSR',
      actionItem: 'Іс-шара',
    },
    fields: {
      area: 'Аудан',
      facilityOperationTeam: 'Нысан операциялық тобы',
      facility: 'Нысан',
      titleStatus: 'Тақырып мәртебесі',
      type: 'Түр',
      title: 'Тақырып',
      project: 'Жоба',
      template: 'Үлгі',
      leadFinalApprover: 'Жетекші/Соңғы мақұлдаушы',
      showOnlyDeletedPssr: 'Тек жойылған PSSR көрсету',
      status: 'Мәртебе',
      priority: 'Басымдық',
      assignedTo: 'Тапсырылған',
      autoLoadImages: 'Суреттерді автоматты жүктеу',
    },
    placeholders: {
      selectOne: 'біреуін таңдаңыз',
      sampleText: 'үлгі мәтін',
      no: 'Жоқ таңдаңыз',
    },
    priorityDescriptions: {
      p3: 'Элементті іске қосу алдында аяқтау керек',
      p4: 'Элемент іске қосудан кейін аяқталады',
      p5: 'Элементті іске қосу алдында аяқтау керек',
    },
    priorityLegend: {
      title: 'Іс-қимыл элементтерінің басымдықтары',
    },
    actions: {
      clearFilter: 'сүзгіні тазалау',
      exportExcel: 'excel экспорттау',
      noDataToExport: 'Экспорттау үшін әрекет элементтері жоқ',
    },
    imageAltText: 'Әрекет Элементінің Суреті',
    pssrTeamLead: 'PSSR топ жетекшісі',
    finalApprover: 'Соңғы мақұлдаушы',
    subsection: 'Ішкі бөлім',
    code: 'Код',
    question: 'Сұрақ',
    answer: 'Жауап',
    noData: 'Іс-шара элементтері жоқ',
    noDataFound: 'Таңдалған сүзгілер бойынша іс-шара элементтері табылмады',
  },
  responseSignature: {
    signedBy: 'Қол қойған',
    signedOn: 'Қол қойған күні',
    name: 'Аты',
    dateCaptured: 'Тіркелген күн',
    sign: 'Қол қою',
    finalApproverLabel: 'Соңғы мақұлдаушы',
    dialogs: {
      deleteHeader: 'Қолтаңбаны жою',
      deleteMessage: 'Қолтаңбаны жоймақшысыз, растау үшін растаңыз',
      cancel: 'болдырмау',
      delete: 'жою',
    },
  },
  userType: {
    Chevron: 'Chevron',
    External: '3-ші тарап (сыртқы)',
    Shared: 'Ортақ',
  },
  areas: {
    title: 'Аудан',
    showDeletedItems: 'Жойылғандарды көрсету',
    areaListTitle: 'Аудан тізімі',
    createFacilityOperationTeam: 'Жаңа нысан операциялық тобын жасау',
    createFacility: 'Жаңа нысан жасау',
    restore: 'Қалпына келтіру',
    emptySubAreaMessage: '<p>Бұл аудан үшін мазмұн жоқ.</p><p>Бастау үшін жаңа нысан операциялық тобын қосыңыз.</p>',
    emptyHierarchyChildrenMessage:
      '<p>Бұл <strong>{{parentLabel}}</strong> үшін <strong>{{childLabel}}</strong> жоқ.</p><p>Бастау үшін жаңа <strong>{{childLabel}}</strong> қосыңыз.</p>',
    emptyAreaMessage: '<p>Бұл бизнес бөлімшесі үшін мазмұн жоқ.</p><p>Бастау үшін жаңа аудан қосыңыз.</p>',
    subareaTitle: 'Нысан операциялық тобы',
    facilityTitle: 'Нысан',
    removeConfirmationHeader: 'Растау',
    confirmDeleteArea: '<strong>{{description}}</strong> ауданын жойғыңыз келе ме?',
    confirmDeleteSubarea: '<strong>{{description}}</strong> нысан операциялық тобын жойғыңыз келе ме?',
    confirmDeleteFacility: '<strong>{{description}}</strong> нысанын жойғыңыз келе ме?',
    restoredSuccessfully: 'Сәтті қалпына келтірілді',
  },
  organizationsList: {
    title: 'Ұйымдар',
    tableHeader: 'ұйым',
    noOrganizations: 'Ұйымдар жоқ',
    successCreated: 'Ұйым сәтті жасалды',
    actions: {
      addNew: 'жаңа ұйым қосу',
    },
    forms: {
      name: 'Ұйым атауы',
      namePlaceholder: 'ұйым атауын теріңіз',
    },
    dialogs: {
      addNew: 'Жаңа ұйым қосу',
      edit: 'Ұйымды өңдеу',
      deleteHeader: 'Ұйымды жою',
      deleteMessage: '[{{name}}] ұйымын жойғыңыз келе ме?',
    },
  },
  userGroupsList: {
    title: 'Іс-шара пайдаланушы топтары',
    groupsSection: 'Топтар',
    noUsers: 'Бұл топта пайдаланушылар жоқ',
    noGroups: 'Топтар жоқ',
    selectGroup: 'Пайдаланушыларды көру үшін топты таңдаңыз',
    actions: {
      create: 'жасау',
      addNewUser: 'жаңа пайдаланушы қосу',
      selectUser: 'Пайдаланушы таңдау',
      changeUser: 'Пайдаланушыны өзгерту',
      add: 'Қосу',
    },
    table: {
      userName: 'пайдаланушы аты',
      email: 'электрондық пошта',
    },
    forms: {
      namePlaceholder: 'Топ атауын енгізіңіз',
      selectUserPrompt: 'Бұл топқа қосу үшін пайдаланушы таңдаңыз',
      selectedUser: 'Таңдалған пайдаланушы',
    },
    dialogs: {
      addGroup: 'Жаңа топ қосу',
      editGroup: 'Топты өңдеу',
      deleteGroupHeader: 'Топты жою',
      deleteGroupMessage: '[{{name}}] тобын жойғыңыз келе ме?',
      removeUserHeader: 'Пайдаланушыны алып тастау',
      removeUserMessage: '{{name}} осы топтан алып тастағыңыз келе ме?',
      addUser: 'Топқа пайдаланушы қосу',
      selectUser: 'Пайдаланушы таңдау',
    },
  },
  pssrImport: {
    title: 'MOC импорттау',
    sections: {
      import: 'Импорт',
    },
    forms: {
      labels: {
        application: 'Қолданба',
        pssrId: 'ID',
        mocId: 'MOC ID',
        mocName: 'MOC атауы',
      },
      placeholders: {
        application: 'біреуін таңдаңыз',
        pssrId: 'MOC ID енгізіңіз',
        mocName: 'iMOC-тен автотолтырылады',
      },
      validation: {
        mocIdRequired: 'MOC ID міндетті',
        applicationRequired: 'Қолданба міндетті',
      },
    },
    actions: {
      add: 'Қосу',
      addMoc: 'MOC қосу',
      importAll: 'Барлығын импорттау',
      createPssr: 'PSSR жасау',
      searchMoc: 'MOC іздеу',
      importMocCreatePssr: 'MOC импорттап PSSR жасау',
    },
    table: {
      id: 'ID',
      pssrId: 'PSSR ID',
      name: 'Атауы',
      status: 'Мәртебе',
    },
    summary: {
      records: 'Жазбалар',
      imported: 'Импортталған',
      errors: 'Қателер',
    },
    status: {
      pending: 'Күтуде',
      inProgress: 'Орындалуда',
      imported: 'Импортталған',
      warning: 'Ескерту',
      error: 'Қате',
    },
    messages: {
      alreadyInList: 'PSSR ID импорт тізімінде бар.',
      pssrNotFound: 'PSSR табылмады.',
    },
  },
  pssrCreate: {
    title: 'PSSR жасау',
    sections: {
      generalInformation: 'Жалпы ақпарат',
      location: 'Орын',
      details: 'Мәліметтер',
      instructions: 'Нұсқаулар',
    },
    forms: {
      labels: {
        title: 'Тақырып',
        moc: 'MOC',
        wo: 'WO',
        description: 'Сипаттама',
        area: 'Аудан',
        facilityOperationTeam: 'Нысан операциялық тобы',
        facility: 'Нысан',
        project: 'Жоба',
        template: 'Үлгі',
        type: 'Түр',
        organization: 'Ұйым',
        subArea: 'Аймақ',
        includeProjectTeam: 'Жоба тобының мүшелерін қосу',
      },
      placeholders: {
        title: 'үлгі мәтін',
        moc: 'үлгі мәтін',
        wo: 'үлгі мәтін',
        description: 'Сипаттаманы енгізіңіз',
        area: 'біреуін таңдаңыз',
        facilityOperationTeam: 'біреуін таңдаңыз',
        facility: 'біреуін таңдаңыз',
        project: 'біреуін таңдаңыз',
        template: 'біреуін таңдаңыз',
        type: 'біреуін таңдаңыз',
        subArea: 'біреуін таңдаңыз',
      },
      validation: {
        titleRequired: 'Тақырып міндетті',
        mocRequired: 'MOC міндетті',
        woRequired: 'WO міндетті',
        businessUnitRequired: 'Бизнес бөлімшесі міндетті',
        organizationRequired: 'Ұйым міндетті',
        areaRequired: 'Аудан міндетті',
        facilityOperationTeamRequired: 'Нысан операциялық тобы міндетті',
        facilityRequired: 'Нысан міндетті',
        projectRequired: 'Жоба міндетті',
        templateRequired: 'Үлгі міндетті',
        typeRequired: 'Түр міндетті',
      },
    },
    actions: {
      create: 'жасау',
      pullFromKMS: 'KMS-тен алу',
    },
    successMessage: 'PSSR сәтті жасалды',
  },
  pssrKms: {
    title: 'KMS-тен PSSR',
    sections: {
      generalInformation: 'Жалпы ақпарат',
      pssrInformation: 'PSSR ақпараты',
      location: 'Орын',
      details: 'Мәліметтер',
    },
    kmsInstruction:
      'KMS-тен деректерді импорттау үшін нақты MOC нөмірін іздеңіз немесе тізімді мәртебе мен бет өлшемі бойынша сүзіңіз.',
    searchMOCNumber: 'MOC нөмірін іздеу',
    mocPattern: 'мыс., MOC-2024-123',
    invalidMOCFormat: 'Жарамсыз MOC форматы. Мысал: MOC-2024-123',
    search: 'Іздеу',
    filterByStatus: 'KMS тізімін мәртебе бойынша сүзу',
    filterPageSize: 'Қайтарылатын KMS элементтері санын сүзу',
    selectFromList: 'KMS MOC тізімінен таңдаңыз',
    selectKMSItems: 'KMS элементтерін таңдаңыз',
    createNew: 'Жаңа жасау',
    enterName: 'Атауын енгізіңіз',
    add: 'Қосу',
    enterProjectNumber: 'Жоба нөмірін енгізіңіз',
    selectQAQCEvent: 'QAQC оқиғасын таңдаңыз',
    selectFromQAQC: 'QAQC-тен таңдаңыз',
    milestones: 'Кезеңдер',
    workOrders: 'Жұмыс тапсырмалары',
    selectMilestone: 'Кезеңді таңдаңыз',
    selectWorkOrder: 'Жұмыс тапсырмасын таңдаңыз',
    milestoneWorkOrders: 'Кезең жұмыс тапсырмалары',
    note: 'Ескертпе',
    fillRequiredFields: 'Міндетті деп белгіленген өрістерді толтырыңыз',
    generatePSSRs: 'PSSR жасау',
    successMessage: 'KMS-тен PSSR сәтті жасалды',
    multipleSuccessMessage: 'KMS-тен бірнеше PSSR сәтті жасалды',
    loadingKMSItemsError: 'KMS элементтерін жүктеу қатесі. Қайталап көріңіз.',
    selectKMSItemsWarning: 'Кем дегенде бір KMS элементін таңдаңыз',
    kmsStatus: {
      draft: 'Жобалама',
      processActivated: 'Процесс іске қосылды',
      reviewInProgress: 'Тексеру жүруде',
      implementationInProgressEdit: 'Орындау жүруде - өңдеу',
      changeRequestApproved: 'Өзгерту сұрауы мақұлданды',
      changeRequestDenied: 'Өзгерту сұрауы қабылданбады',
      implementationInProgress: 'Орындау жүруде',
      readyToStartUp: 'Іске қосуға дайын',
      completed: 'Аяқталды',
      canceled: 'Болдырылмады',
      onHold: 'Тоқтатылды',
    },
    businessUnit: 'Бизнес бөлімшесі',
    selectPlaceholder: 'Біреуін таңдаңыз',
  },
  pssrSubSections: {
    actions: {
      addQuestion: 'Сұрақ қосу',
    },
  },
  pssrDetails: {
    pssrId: 'PSSR ID',
    title: 'PSSR мәліметтері',
    sections: {
      generalInformation: 'Жалпы ақпарат',
      location: 'Орын',
      details: 'Мәліметтер',
      sectionsTitle: 'Бөлімдер',
      comments: 'Пікірлер',
      actionItems: 'Іс-шара элементтері',
      enableCustomOrderForSections: 'Бөлімдер үшін реттелетін тәртіпті қосу',
      sectionsLegendTitle: 'Бөлімдер кілті',
      hideCompletedQuestions: 'Аяқталған сұрақтарды жасыру',
      saveSectionOrder: 'Бөлімдер тәртібін сақтау',
      confirmRemoveSectionTitle: 'Бөлімді алып тастау',
      confirmRemoveSectionDescription: '{{description}} алып тастағыңыз келе ме?',
      sectionNameLabel: 'Бөлім атауы',
      sectionNamePlaceholder: 'Бөлім атауын енгізіңіз',
      editSectionName: 'Бөлім атауын өңдеу',
      addMultipleSectionName: 'Бірнеше бөлім қосу',
      validation: {
        sectionNameRequired: 'Бөлім атауы міндетті',
        sectionNameDuplicated: 'Осы атаумен бөлім бар',
      },
      toast: {
        unableToCompleteOperation: 'Операцияны аяқтау мүмкін емес',
        saveCompletedTitle: 'Сақтау аяқталды',
        sectionsSortedSuccessfully: 'Бөлімдер сәтті сұрыпталды',
        loadSectionsError: 'Бөлімдерді жүктеу қатесі. Қайталап көріңіз.',
        userAlreadyAdded: 'Пайдаланушы бұрыннан қосылған',
        userAddedSuccessfully: 'Пайдаланушы сәтті қосылды',
        sectionAddedSuccessfully: 'Бөлім сәтті қосылды',
        sectionUpdatedSuccessfully: 'Бөлім сәтті жаңартылды',
      },
      selectLead: 'жетекшіні таңдаңыз',
      section1Title: '1-бөлім',
      legend: {
        defaultQuestionLabel: 'әдепкі сұрақ',
        defaultQuestionDescription: 'иә, жоқ немесе н/қ арқылы жауап берілетін сұрақ',
        optionalLabel: 'қосымша',
        optionalDescription: 'PSSR-ге қолмен қосылуы мүмкін',
        multipleLabel: 'бірнеше',
        multipleDescription: 'қосымша, бірақ PSSR-ге бірнеше рет қосылуы мүмкін',
        mandatoryLabel: 'міндетті',
      },
      instructions: 'Нұсқаулар',
      history: 'PSSR өзгерістер тарихы',
      attachments: 'PSSR тіркемелері',
    },
    subsections: {
      actionItemNeeded: 'Ескертпе: Сұрақтарды аяқтау үшін іс-шара элементі қажет.',
    },
    questions: {
      code: 'Код',
      question: 'Сұрақ',
      answer: 'Жауап',
      updatedBy: 'Жаңартқан',
      updatedDate: 'Жаңарту күні',
      clearAnswer: 'жауапты тазалау',
      deleteQuestion: 'сұрақты жою',
      answerUpdated: 'Жауап сәтті жаңартылды',
      answerCleared: 'Жауап сәтті тазаланды',
      questionDeleted: 'Сұрақ сәтті жойылды',
      confirmDeleteTitle: 'Сұрақты жою',
      confirmDeleteMessage: 'Бұл сұрақты жойғыңыз келе ме: {{question}}?',
      validation: {
        actionItemIsNeeded: 'Сұрақты аяқтау үшін іс-шара элементі қажет',
        commentIsNeeded: 'Сұрақты аяқтау үшін пікір қажет',
        signatureIsNeeded: 'Сұрақты аяқтау үшін қолтаңба қажет',
        responseIsNeeded: 'Сұрақты аяқтау үшін жауап қажет',
        actionItemsClosedOrCancelledNeeded:
          'Сұрақты аяқтау үшін жабылған немесе болдырылмаған {{P3Label}} іс-шара элементтері қажет',
      },
    },
    forms: {
      labels: {
        title: 'Тақырып',
        moc: 'MOC',
        wo: 'WO',
        description: 'Сипаттама',
        area: 'Аудан',
        facilityOperationTeam: 'Нысан операциялық тобы',
        facility: 'Нысан',
        project: 'Жоба',
        template: 'Үлгі',
        type: 'Түр',
      },
      placeholders: {
        title: 'үлгі мәтін',
        moc: 'үлгі мәтін',
        wo: 'үлгі мәтін',
        description: 'Сипаттаманы енгізіңіз',
        area: 'біреуін таңдаңыз',
        facilityOperationTeam: 'біреуін таңдаңыз',
        facility: 'біреуін таңдаңыз',
        project: 'біреуін таңдаңыз',
        template: 'біреуін таңдаңыз',
        type: 'біреуін таңдаңыз',
      },
      validation: {
        titleRequired: 'Тақырып міндетті',
        businessUnitRequired: 'Бизнес бөлімшесі міндетті',
        organizationRequired: 'Ұйым міндетті',
        areaRequired: 'Аудан міндетті',
        facilityOperationTeamRequired: 'Нысан операциялық тобы міндетті',
        facilityRequired: 'Нысан міндетті',
        templateRequired: 'Үлгі міндетті',
        requiredFieldsMessage: 'Ескерту: Міндетті деп белгіленген өрістерді толтырыңыз. Сақтау түймесін басыңыз.',
        typeRequired: 'Түр міндетті',
      },
      templateChangeConfirmTitle: 'Үлгіні өзгерту',
      templateChangeConfirmMessage:
        'Үлгіні өзгерту ППТБ бөлімдерін жаңартады. Үлгіні өзгерткіңіз келетініне сенімдісіз бе?',
    },
    actions: {
      save: 'сақтау',
      saveGeneralInformation: 'жалпы ақпаратты сақтау',
      showFullHistory: 'толық тарихты көрсету',
      showLessHistory: 'аз тарихты көрсету',
      attachFile: 'Файл тіркеу (құжаттар, суреттер, psi сызбалар, т.б.)',
      attachFileButton: 'файл тіркеу',
      printToPdf: 'pdf-ке басып шығару',
      sendEmailReminder: 'электрондық пошта еске салуын жіберу',
      importMocActionItems: 'moc іс-шара элементтерін импорттау',
      sendToMocStartup: 'іске қосу мақұлдауы үшін moc жазбасына жіберу',
      returnToTeamLead: 'топ жетекшісіне қайтару',
      start: 'pssr бастау',
      reject: 'қабылдамау',
      delete: 'жою',
      restorePssr: 'pssr қалпына келтіру',
      reopen: 'қайта ашу',
    },
    mocImportedHint: 'Бұл PSSR импортталған. Оның идентификаторын өзгерту мүмкін емес',
    history: {
      reason: 'Себебі',
      by: 'Кім',
      draftCreated: 'Жобалама жасалған',
      initiated: 'Бастамаланған',
      started: 'Басталған',
      completed: 'Аяқталған',
      pendingApproval: 'Мақұлдау күтуде',
      verbalApproval: 'Ауызша мақұлдау',
      approved: 'Мақұлданған',
      rejected: 'Қабылданбаған',
      restored: 'Қалпына келтірілген',
      deleted: 'Жойылған',
      closed: 'Жабылған',
    },
    successMessage: 'PSSR сәтті жаңартылды',
    pdfDownloadSuccess: 'PDF сәтті жүктелді',
    pssrDeletedSuccess: 'PSSR сәтті өшірілді',
    pssrReopenedSuccess: 'PSSR сәтті қайта ашылды',
    statusChangedSuccess: 'PSSR мәртебесі сәтті өзгертілді',
    pssrRejectedSuccess: 'PSSR сәтті қабылданбады',
    pssrRestoredSuccess: 'PSSR сәтті қалпына келтірілді',
    importMOCActionsSuccess: 'MOC іс-шара элементтері сәтті импортталды',
    sendToMOCSuccess: 'MOC-қа сәтті жүктелді',
    emailSentSuccess: 'Электрондық пошта еске салуы сәтті жіберілді',
    importMOCActionsNone: 'Импорттауға MOC іс-шара элементтері жоқ',
    lastSent: 'Соңғы жіберілген',
    messages: {
      questionAdded: 'Сұрақ сәтті қосылды',
    },
    dialogs: {
      addQuestion: {
        descriptionLabel: 'Сипаттама',
        descriptionPlaceholder: 'Сұрақ сипаттамасын енгізіңіз',
        descriptionRequired: 'Сипаттама міндетті',
      },
    },
    rejectDialog: {
      title: 'PSSR-ді қабылдамау',
      reasonLabel: 'Қабылдамау себебі',
      cancel: 'Болдырмау',
      confirm: 'Қабылдамау',
    },
    emailReminderDialog: {
      title: 'Электрондық пошта еске салуын жіберу',
      sendReminder: 'Еске салу жіберу',
      sendMessage: 'Реттелетін хабар жіберу',
      reminderInstructions:
        'Барлық ашық AI үшін тапсырылғандарға еске салу жіберу. PSSR мақұлдау күту мәртебесінде болса, мақұлдаушылар хабарландыру алады.',
      messageInstructions: 'Барлық PSSR қатысушыларына электрондық пошта жіберу',
      enterText: 'Хабарыңызды енгізіңіз...',
      cancel: 'Болдырмау',
      confirm: 'Жіберу',
    },
    commentDialog: {
      title: 'Пікір',
      commentLabel: 'Пікір',
      commentPlaceholder: 'үлгі мәтін',
      createdBy: 'Жасаған',
      updatedDate: 'Жаңарту күні',
      updatedBy: 'Жаңартқан',
      documents: 'Құжаттар',
      delete: 'жою',
      cancel: 'болдырмау',
      save: 'сақтау',
      successMessage: 'Пікір сәтті жаңартылды',
      confirmDeleteAttachment: 'Бұл тіркемені жойғыңыз келе ме?',
      confirmDeleteAttachmentHeader: 'Тіркемені жою',
      commentRequired: 'Пікір міндетті',
      addComment: 'Пікір қосу',
      editComment: 'Пікірді өңдеу',
      confirmDelete: 'Бұл пікірді жойғыңыз келе ме?',
      confirmDeleteHeader: 'Пікірді жою',
      commentAdded: 'Пікір сәтті қосылды',
      commentUpdated: 'Пікір сәтті жаңартылды',
      commentDeleted: 'Пікір сәтті жойылды',
    },
    confirmDeleteHeader: 'Жоюды растау',
    confirmDeleteMessage: 'Осы элементті жоймақшысыз. Жалғастырғыңыз келе ме?',
    confirmDeleteComment: 'Бұл пікірді жойғыңыз келе ме?',
    commentDeletedSuccess: 'Пікір сәтті жойылды',
    changeStatusHeader: 'Мәртебе өзгерісін растау',
    confirmChangeStatus: 'Мәртебені өзгерткіңіз келе ме?',
    confirmReturnToTeamLead: 'Бұл PSSR-ді Команда Көшбасшысына қайтарғыңыз келе ме?',
    confirmRejectHeader: 'Қабылдамауды растау',
    confirmRejectMessage: 'Бұл PSSR-ді қабылдамағыңыз келе ме?',
    confirmReopenHeader: ' ',
    confirmReopenMessage: 'Бұл PSSR-ді қайта ашқыңыз келе ме?',
    comments: {
      title: 'Пікірлер',
      addComment: 'пікір қосу',
      noComments: 'Пікірлер жоқ',
      by: 'кімнен',
      on: 'күні',
    },
    validation: {
      onlyPSSRTeamLeadcanInitiatePSSR: 'PSSR-ді тек PSSR топ жетекшісі бастамалай алады',
      requireFinalApproverBeforeInitiation: 'Бастамалар алдында соңғы мақұлдаушы міндетті',
      pssrMustAnswerAllQuestionsToCompleteWalkdown:
        'Аралауды аяқтау үшін барлық сұрақтарға жауап беріліп, барлық қолтаңбалар алынуы тиіс',
      pssrMustHaveFinalApproverToCompleteWalkdown: 'Аралауды аяқтау үшін PSSR-де соңғы мақұлдаушы болуы тиіс',
      onlyPSSRTeamLeadcanSubmitforPendingApproval: 'Күтілетін мақұлдауға тек PSSR топ жетекшісі жібере алады',
      p3ActionItemsMustBeClosed: 'P3 іс-шара элементтері жабылуы тиіс',
      p4ActionItemsMustBeClosed: 'P4 іс-шара элементтері жабылуы тиіс',
      onlyFinalApprovercanApprovePSSR: 'PSSR-ді тек соңғы мақұлдаушы мақұлдай алады',
      onlyPSSRTeamLeadClosePSSR: 'PSSR-ді тек PSSR топ жетекшісі жаба алады',
    },
  },
  pdfDialog: {
    header: 'PDF файлын ?осу',
    selectTypePrompt: 'Б?л PDF-ті ?алай ?осу?а ?алайсыз?',
    document: '??жат',
    image: 'Сурет',
    selectPagesTitle: 'Суреттерге т?рлендіру ?шін беттерді та?да?ыз',
    allPages: 'Барлы? беттер',
    selectPages: 'Беттерді та?дау',
    page: 'Бет',
    select: 'Та?дау',
    couldNotDetectPages: 'Беттер саны аны?талмады. Барлы? беттер ?осылады.',
  },
  attachmentUpload: {
    title: 'Файл тіркеу',
    selectType: 'Не тіркегіңіз келеді?',
    types: {
      link: 'Сілтеме',
      document: 'Құжат',
      image: 'Сурет',
    },
    forms: {
      url: 'URL',
      urlPlaceholder: 'https://example.com',
    },
    clickToSelect: 'Файл таңдау үшін басыңыз',
    acceptedImageTypes: 'Қабылданатын форматтар: JPG, PNG, GIF, т.б.',
    acceptedDocumentTypes: 'Қабылданатын форматтар: PDF, DOC, DOCX, XLS, XLSX',
    upload: 'Жүктеу',
    successMessage: 'Файл сәтті тіркелді',
    sections: {
      images: 'Суреттер',
      documents: 'Құжаттар',
      links: 'Сілтемелер',
    },
    uploaded: 'Жүктелді',
    download: 'Жүктеп алу',
  },
  participants: {
    title: 'Қатысушылар',
    addParticipant: 'қатысушы қосу',
    addMember: 'Мүше қосу',
    pssrTeamLead: '{{pssrTitle}} топ жетекшісі',
    pssrTeam: '{{pssrTitle}} тобы',
    projectManagers: 'Жоба менеджерлері',
    projectTeamMembers: 'Жоба тобы мүшелері',
    operationsRepresentative: 'Операциялар өкілі',
    finalApprover: 'Соңғы мақұлдаушы',
    actionItemAssignee: 'Әрекет тапсырмасын орындаушы',
    noParticipantsAdded: 'Қатысушылар қосылмаған',
    signedBy: 'Қол қойған',
    signedInBehalfOf: 'атынан қол қойылған',
    signedOn: 'Қол қойған күні',
  },
  qaqcImport: {
    title: 'QAQC импорты',
    milestone: 'QAQC кезеңі',
    workOrders: 'QAQC жұмыс тапсырмалары',
    milestoneWorkOrders: 'QAQC кезеңінің жұмыс тапсырмалары (қосымша)',
    milestoneWorkOrdersLabel: 'QAQC кезеңінің жұмыс тапсырмалары',
    milestoneWorkOrdersMessage: 'Кезең ішіндегі жұмыс тапсырмаларын көру үшін 1 кезеңді таңдаңыз',
    noItemsAvailable: 'QAQC-тен қол жетімді кезеңдер/жұмыс тапсырмалары жоқ',
    noWorkOrdersForMilestone: 'Бұл кезең үшін жұмыс тапсырмалары жоқ',
    unableLoadItems:
      'QAQC жүйесіне кезеңдер/жұмыс тапсырмалары бойынша қол жеткізу мүмкін емес, кейінірек қайталап көріңіз',
    loadEventsError: '{{eventLabel}} деректерін QAQC жүйесінен алу қатесі',
    multipleMilestonesWarning: 'Кезең ішіндегі жұмыс тапсырмаларын көру үшін 1 кезеңді таңдаңыз',
    generatePssrTitle: 'PSSR тақырыбын жасау',
    alreadyExists: 'Бұл QAQC оқиғасы жоба ретінде бар',
    selectEvent: 'Жоба',
    sections: 'Бөлімдер',
    assignSectionLeads: 'Бөлім жетекшілерін тағайындау',
    selectLead: 'Жетекшіні таңдаңыз',
    sectionName: 'Бөлім атауы',
    lead: 'Жетекші',
    template: 'Үлгі',
    type: 'Түр',
    projectType: 'Жоба түрі',
    successMessage: 'QAQC импорты сәтті аяқталды. Жоба және PSSR жасалды.',
    errorMessage: 'QAQC жобасын жасау қатесі. Қайталап көріңіз.',
    projectCreatedWithoutItems:
      'Жоба жасалды. QAQC-те әзірге кезеңдер мен жұмыс тапсырмалары жоқ; олар пайда болған кезде "Жаңа QAQC элементтерін жүктеу" түймесін пайдаланыңыз.',
    partialErrorMessage:
      'Жоба жасалды, бірақ оның PSSR-лерін жасау мүмкін болмады. Қайталау үшін "Жаңа QAQC элементтерін жүктеу" түймесін пайдаланыңыз.',
    somePssrsNotCreated:
      '{{total}} PSSR-дің тек {{created}} жасалды. Қалғандарын жасау үшін "Жаңа QAQC элементтерін жүктеу" түймесін пайдаланыңыз.',
  },
  participantDialog: {
    title: 'Қатысушы таңдау',
    addParticipant: 'Қатысушы қосу',
    selectUserType: 'Пайдаланушы түрін таңдаңыз',
    selectedUserType: 'Таңдалған пайдаланушы түрі',
    chevronDirectory: 'chevron анықтамалығы/ортақ пайдаланушылар',
    newNonChevron: 'жаңа chevron емес',
    searchPlaceholder: 'Электрондық пошта бойынша іздеу...',
    emailPlaceholder: 'Электрондық поштаны енгізіңіз...',
    namePlaceholder: 'Атауды енгізіңіз...',
    selectRole: 'Рөлді таңдаңыз',
    selectedRole: 'Таңдалған рөл',
    selectOne: 'біреуін таңдаңыз',
    add: 'қосу',
    successMessage: 'Қатысушы сәтті қосылды',
    added: 'Қатысушы сәтті қосылды',
    addError: 'Қатысушы қосу қатесі',
    alreadyParticipantPssr: 'Бұл пайдаланушы бұрыннан осы ІҚАҚТ қатысушысы {{role}} ретінде',
    alreadyMemberProject: 'Бұл пайдаланушы бұрыннан осы жоба мүшесі {{role}} ретінде',
    stagedParticipants: 'қосылатындар:',
    batchLimitReached: '{{limit}} пайдаланушы шегіне жетті, қосу басыңыз',
    alreadyStagedError: 'бұл пайдаланушы тізімде бар',
  },
  participantEditDialog: {
    title: 'Қатысушыны өңдеу',
    user: 'Пайдаланушы',
    selectRole: 'Рөлді таңдаңыз',
    delete: 'жою',
    captureSignature: 'қолтаңба алу',
    recaptureSignature: 'қолтаңбаны қайта алу',
    removeSignature: 'қолтаңбаны алып тастау',
    removeSignatureSuccess: 'Қолтаңба сәтті алып тасталды',
    save: 'сақтау',
    noSignature: 'Қолтаңба алынбаған',
    successMessage: 'Қатысушы сәтті жаңартылды',
    deleteSuccessMessage: 'Қатысушы сәтті алып тасталды',
    deleteConfirmHeader: 'Қатысушыны жою',
    deleteConfirmMessage: 'Бұл қатысушыны алып тастағыңыз келе ме?',
  },
  buAdminsList: {
    title: 'ББ пайдаланушы әкімдері',
    actions: {
      addNewUser: 'әкімші пайдаланушы қосу',
      delete: 'жою',
    },
    table: {
      fullName: 'толық аты',
      email: 'электрондық пошта',
    },
    noAdmins: 'Әкімші пайдаланушылар жоқ',
  },
  externalUserForm: {
    labels: {
      firstName: 'Аты',
      lastName: 'Тегі',
      email: 'Электрондық пошта',
      userNameEmail: 'Пайдаланушы аты немесе электрондық пошта',
    },
  },
  sharedUserForm: {
    labels: {
      sharedUserGroup: 'Ортақ пайдаланушы тобы',
      sharedEmail: 'Ортақ электрондық пошта',
    },
    actions: {
      importSharedUsers: 'Ортақ пайдаланушыларды импорттау',
      addChildUser: 'пайдаланушы қосу',
    },
    whitePages: {
      title: 'White Pages интеграциясы',
      description:
        'White Pages-пен синхрондау қажет болса, осы ортақ электрондық поштаны пайдаланыңыз. Пайдаланушылар тізімі уақыт өте келе автоматты жаңартылады. Кейбір пайдаланушылар автоматты қосылуы немесе алынуы мүмкін.',
    },
    customConfiguration: {
      title: 'Реттелетін конфигурация',
      description: 'Пайдаланушылар тізімін қолмен басқарыңыз.',
    },
  },
  pssrsList: {
    title: 'PSSR',
    location: 'Орын',
    details: 'Мәліметтер',
    emptyMessage: 'PSSR табылмады',
    searchByLocation: 'Орын бойынша іздеу',
    searchByDetails: 'Мәліметтер бойынша іздеу',
    filters: {
      businessUnit: 'Бизнес бөлімшесі',
      organization: 'Ұйым',
      area: 'Аудан',
      subArea: 'Ішкі аудан',
      facilityOperationTeam: 'Нысан операциялық тобы',
      facility: 'Нысан',
      project: 'Жоба',
      template: 'Үлгі',
      selectOne: 'Біреуін таңдаңыз',
      status: 'Мәртебе',
      type: 'Түр',
      deletedStagnant: 'Жойылған/Тұрақсыз',
      showOnlyDeleted: 'тек жойылған PSSR көрсету',
      showOnlyStagnant: 'тек тұрақсыз PSSR көрсету',
      userSearch: 'Пайдаланушы іздеу',
      placeholderUserSearch: 'үлгі мәтін',
      search: 'Іздеу',
      placeholderSearch: 'moc, wo, pssr id, тақырып, т.б. бойынша PSSR іздеу...',
      isStagnant: 'Тұрақсыз',
      isDeleted: 'Жойылған',
    },
    buttons: {
      clearFilter: 'сүзгіні тазалау',
      newPssr: 'жаңа PSSR',
      viewItems: 'элементтерді қарау',
      open: 'ашу',
    },
    actions: {
      clearFilter: 'Сүзгіні тазалау',
      newPssr: 'жаңа pssr',
      importPssr: 'pssr импорттау',
    },
    table: {
      id: 'ID',
      title: 'Тақырып',
      type: 'Түр',
      status: 'Мәртебе',
      facility: 'Нысан',
      project: 'Жоба',
    },
    statusOptions: {
      draft: 'Жобалама',
      initiated: 'Бастамаланған',
      inProgress: 'Орындалуда',
      completed: 'Аяқталды',
      pendingApproval: 'Мақұлдау күтуде',
      approved: 'Мақұлданған',
      closed: 'Жабылған',
    },
    noPssrs: 'PSSR жоқ',
  },
  pssrListItem: {
    pssrId: 'PSSR ID',
    pssr: 'PSSR',
    moc: 'MOC',
    wo: 'WO',
    project: 'Жоба',
    teamLeads: 'Топ жетекшілері',
    totalQuestions: 'Жалпы сұрақтар',
    outstandingQuestions: 'Қалған сұрақтар',
    completedQuestions: 'Аяқталған сұрақтар',
    area: 'Аудан',
    subArea: 'Ішкі аудан',
    facility: 'Нысан',
    qaqcStatus: 'QAQC күйі',
    qaqcMilestone: 'QAQC кезеңі',
    qaqcWorkOrder: 'QAQC жұмыс тапсырмасы',
    qaqcReady: '% дайын',
    qaqcComplete: '% аяқталған',
    qaqcAccepted: '% қабылданған',
    qaqcSignatures: 'Қолдар',
    qaqcDocuments: 'QAQC құжаттары',
    qaqcNoData: 'QAQC деректері жоқ',
  },
  pssrStatuses: {
    Draft: 'Жобалама',
    Initiated: 'Бастамаланған',
    InProgress: 'Орындалуда',
    Completed: 'Аяқталды',
    PendingApproval: 'Мақұлдау күтуде',
    Approved: 'Мақұлданған',
    Closed: 'Жабылған',
    Deleted: 'Жойылған',
    CreateDate: 'Жобалама жасалған',
    InitiatedOn: 'Бастамаланған',
    StartedOn: 'Басталған',
    CompletedOn: 'Аралау аяқталған',
    PendingApprovalOn: 'Мақұлдауға жіберілген',
    ApprovedOn: 'Мақұлданған',
    ClosedOn: 'Жабылған',
    DeletedOn: 'Жойылған',
    RestoredOn: 'Қалпына келтірілген',
  },
  signatureCaptureDialog: {
    title: 'Қолтаңба алу',
    confirm: 'растау',
    saveSuccess: 'Қолтаңба сәтті алынды',
  },
  projectsList: {
    title: 'Жобалар',
    table: {
      projectName: 'Жоба атауы',
      projectManager: 'Жоба менеджері',
      status: 'Мәртебе',
      completedTotalPssrs: 'Аяқталған/жалпы PSSR',
      actions: 'Іс-қимылдар',
      dateCreated: 'Жасалған күні',
    },
    statusLabels: {
      active: 'белсенді',
      closed: 'жабылған',
    },
    sort: {
      placeholder: 'Сұрыптау',
      nameAsc: 'Аты (А-Я)',
      nameDesc: 'Аты (Я-А)',
      statusAsc: 'Мәртебе (Төменнен жоғарыға)',
      statusDesc: 'Мәртебе (Жоғарыдан төменге)',
      dateAsc: 'Жасалған күні (Ескіден жаңаға)',
      dateDesc: 'Жасалған күні (Жаңадан ескіге)',
    },
    actions: {
      open: 'ашу',
      createProject: 'жоба жасау',
    },
    projectSearch: 'Жоба іздеу',
    showDeletedProjects: 'Жойылған жобаларды көрсету',
    searchPlaceholder: 'Атауы, ID немесе сипаттамасы бойынша іздеу',
    datePlaceholder: 'мм/кк/жж - мм/кк/жж',
    statusPlaceholder: 'біреуін таңдаңыз',
    noProjects: 'Жобалар жоқ',
  },
  projectEdit: {
    title: 'Жобаны өңдеу',
    projectName: 'Жоба атауы',
    projectNamePlaceholder: 'Жоба атауын енгізіңіз',
    statusActive: 'белсенді',
    statusClosed: 'жабылған',
    statusDeleted: 'жойылған',
    teamMembers: 'Топ мүшелері',
    addParticipant: 'қатысушы қосу',
    pssrCcc: 'ППТБ/ҚСС',
    newPssr: 'Жаңа {{pssrTitle}}',
    noPssrCcc: 'Бұл жобамен байланысты PSSR/CCC жоқ.',
    delete: 'Жою',
    markAsClosed: 'Жабылған деп белгілеу',
    reopen: 'Қайта ашу',
    confirmDelete: 'Бұл жобаны жойғыңыз келе ме?',
    confirmDeleteHeader: 'Жоюды растау',
    confirmDeletePssrs: 'Бұл жобамен байланысты барлық PSSR-ді де жойғыңыз келе ме?',
    confirmDeletePssrsHeader: 'PSSR-ді жою?',
    deleteSuccess: 'Жоба сәтті жойылды',
    confirmMarkAsClosed: 'Бұл жобаны жабылған деп белгілегіңіз келе ме?',
    confirmMarkAsClosedHeader: 'Жабылған деп белгілеуді растау',
    markedAsClosedSuccess: 'Жоба сәтті жабылған деп белгіленді',
    confirmCloseProjectTitle: 'Жобаны жабуды растау',
    confirmCloseProjectDescription: 'Бұл жобаны жабылған деп белгілегіңіз келе ме?',
    confirmReopenProjectTitle: 'Жобаны қайта ашуды растау',
    confirmReopenProjectDescription: 'Бұл жобаны қайта ашқыңыз келе ме?',
    cannotCloseProjectDueOpenPSSRs: 'Жобаны жабу мүмкін емес, себебі ашық PSSR бар.',
    projectUpdatedSuccessfully: 'Жоба сәтті жаңартылды',
    loadNewQaqcItems: 'Жаңа QAQC элементтерін жүктеу',
    qaqcItemsLoadedSuccessfully: 'Жаңа QAQC элементтері сәтті жүктелді',
    qaqcItemsUpToDate: 'QAQC элементтері өзекті',
    qaqcInputWarning: 'Жаңа элементтерді жүктер алдында міндетті QAQC өрістерін толтырыңыз: {{fields}}.',
    initiateAll: 'Барлық PSSR бастау',
    initiateAllTitle: 'Барлық PSSR бастау',
    initiateAllDescription: 'Осы жобаның барлық PSSR бастағыңыз келе ме?',
    initiateAllSuccess: 'Барлық PSSR сәтті басталды',
    initiateAllPartialError: 'Кейбір PSSR бастау мүмкін болмады:',
    projectReopenedSuccessfully: 'Жоба сәтті қайта ашылды',
    restorePssr: 'Қалпына келтіру',
    confirmRestoreProject: 'Бұл жобаны қалпына келтіргіңіз келе ме?',
    confirmRestoreProjectHeader: 'Қалпына келтіруді растау',
    restoreSuccess: 'Жоба сәтті қалпына келтірілді',
    deleteDialog: {
      title: 'Жобаны жоюды растау',
      confirmDeleteWithPssrs: 'Бұл іс-қимыл Жобаны және байланысты PSSR-ді жоюы мүмкін. Жалғастырғыңыз келе ме?',
      confirmDeleteWithoutPssrs: 'Жалғастырғыңыз келе ме?',
      deleteProjectAndPssrs: 'Жоба мен PSSR-ді жою',
      deleteProjectOnly: 'Тек жобаны жою',
      deleteSuccess: 'Жоба сәтті жойылды',
      deleteError: 'Жобаны жою қатесі',
    },
    cascadeDialog: {
      cascade: 'каскадтау',
      title: 'Рөлдерді каскадтау',
      description: 'Бұл жобаның барлық PSSR-іне каскадтағыңыз келетін қатысушыларды таңдаңыз.',
      teamLeads: 'Топ жетекшілері',
      teamMembers: 'Топ мүшелері',
      operationsRepresentative: 'Операциялар өкілі',
      finalApprover: 'Соңғы мақұлдаушы',
      apply: 'қолдану',
      success: 'Рөлдер сәтті каскадталды',
    },
    errors: {
      noPermissionToEditParticipants: 'Бұл жобада қатысушыларды өңдеуге рұқсатыңыз жоқ',
    },
  },
  multiselect: {
    selectedItems: '{0} элемент таңдалды',
    placeholder: 'таңдаңыз',
  },
  support: {
    title: 'Пікір',
    buSupportInfo: 'ePSSR ББ қолдау ақпараты',
    serviceNowInstructions: 'ePSSR Service Now билет нұсқаулары',
    instructions: {
      step1:
        'Chevron IT қызмет порталындағы <a class="support-link" href="https://chevron.service-now.com/mychevron?id=sc_cat_item_guide&sys_id=9c08a21edb126450182e1dca48961981&sysparm_u_appid=1500000886" target="_blank" rel="noopener">Қолданба қолдау сұрауы</a> нысанына өтіңіз',
      step1LinkText: 'Қолданба қолдау сұрауы',
      step2: 'Қолданба өрісінде <b>Mobile PSSR</b> таңдаңыз.',
      step3:
        'Мәселені немесе қатені хабарлау үшін <b>Мәселені хабарлау</b> таңдаңыз. Жетілдіру сұрауы немесе пайдаланушы қол жетімділік сұрауы үшін <b>Қызмет сұрауы</b> таңдаңыз. Келесіні басыңыз.',
    },
    reportIssue: {
      title: 'Мәселені хабарлау',
      step1: 'Мәселе сипаттамасын, ықпалы мен шұғылдылығын толтырыңыз.',
      step2: 'Келесіні, содан кейін Жіберуді басыңыз.',
      step3: 'ePSSR қолдау тобы жұмыс уақытында 24 сағат ішінде билет алғанын растайды.',
    },
    enhancement: {
      title: 'Жетілдіру сұрауы',
      step1: 'Сұрау түрлері астындағы <b>Жетілдірулер</b> таңдаңыз.',
      step2: 'Басымдықты таңдаңыз (<b>Төмен, Орташа, Жоғары</b>)',
      step3: 'Сұрау сипаттамасын толтырыңыз',
      step4: 'Келесіні таңдаңыз және жіберіңіз.',
      step5: 'ePSSR қолдау тобы жетілдіру сұрауларын Surface Digital PI жоспарлау процесі аясында қарастырады',
    },
    userAccess: {
      title: 'Пайдаланушы қол жетімділік сұрауы',
      step1: 'Сұрау түрлері астындағы <b>Қол жетімділік сұрау</b> таңдаңыз.',
      step2: 'Қол жетімділік сұрауының түрін таңдаңыз (<b>Қосу немесе Алып тастау</b>)',
      step3: 'Пайдаланушыны таңдаңыз',
      step4: 'Басымдықты таңдаңыз (<b>Төмен, Орташа, Жоғары</b>)',
      step5: 'Рөлді және пайдаланушыға қажетті қол жетімділікті көрсетіңіз.',
      step6: 'Келесіні таңдаңыз және жіберіңіз.',
      step7: 'ePSSR қолдау тобы жұмыс уақытында 24 сағат ішінде билет алғанын растайды.',
    },
  },
  datepicker: {
    dayNames: ['Жексенбі', 'Дүйсенбі', 'Сейсенбі', 'Сәрсенбі', 'Бейсенбі', 'Жұма', 'Сенбі'],
    dayNamesShort: ['Жек', 'Дүй', 'Сей', 'Сәр', 'Бей', 'Жұм', 'Сен'],
    dayNamesMin: ['Жк', 'Дс', 'Сс', 'Ср', 'Бс', 'Жм', 'Сб'],
    monthNames: [
      'Қаңтар',
      'Ақпан',
      'Наурыз',
      'Сәуір',
      'Мамыр',
      'Маусым',
      'Шілде',
      'Тамыз',
      'Қыркүйек',
      'Қазан',
      'Қараша',
      'Желтоқсан',
    ],
    monthNamesShort: ['Қаң', 'Ақп', 'Нау', 'Сәу', 'Мам', 'Мау', 'Шіл', 'Там', 'Қыр', 'Қаз', 'Қар', 'Жел'],
    today: 'Бүгін',
    clear: 'Тазалау',
    dateFormat: 'mm/dd/yy',
    weekHeader: 'Ап',
  },
  errors: {
    unauthorized: {
      title: 'Рұқсат етілмеген қолжеткізу',
      message: 'Бұл бетке кіруге рұқсатыңыз жоқ.',
    },
    serverError: {
      title: 'Сервер қатесі',
      message: 'Күтпеген қате орын алды. Кейінірек қайталап көріңіз.',
    },
    pageNotFound: {
      title: 'Бет табылмады',
      message: 'Сіз іздеген бет жоқ.',
    },
    actions: {
      returnHome: 'Басты бетке оралу',
    },
  },
  attachments: {
    sections: {
      images: 'Суреттер',
      documents: 'Құжаттар',
      links: 'Сілтемелер',
    },
    actions: {
      download: 'Жүктеп алу',
      delete: 'Жою',
    },
    labels: {
      uploaded: 'Жүктелген',
    },
  },
  imagePreview: {
    errorMessage: 'Суретті жүктеу сәтсіз аяқталды',
    errorDetails: 'Толығырақ ақпарат үшін браузер консолін тексеріңіз',
  },
  functionalReview: {
    audit: {
      createdBy: 'Жасаған',
      updatedDate: 'Жаңартылған күні',
      updatedBy: 'Жаңартқан',
    },
  },
  checklistItem: {
    toolbar: {
      bold: 'Қалың',
      italic: 'Көлбеу',
      underline: 'Асты сызылған',
      orderedList: 'Реттелген тізім',
      unorderedList: 'Реттелмеген тізім',
      codeBlock: 'Код блогы',
      blockQuote: 'Дәйексөз блогы',
    },
    alignment: {
      center: 'ортаға',
      right: 'оңға',
      justify: 'екі жаққа',
    },
  },
  pssrSections: {
    actions: {
      removeUser: 'Пайдаланушыны жою',
    },
  },
  pssrParticipantsSections: {
    actions: {
      remove: 'Жою',
    },
  },
  progressBar: {
    label: 'Прогресс:',
  },
  categories: {
    dialogs: {
      addCategory: 'Санатын қосу',
      editCategory: 'Санатын өңдеу',
      createSubCategory: 'Жаңа ішкі санатын құру',
      editSubCategory: 'Ішкі санатын өңдеу',
    },
    placeholders: {
      subcategoryName: 'Ішкі санат атауы',
    },
  },
  categoriesList: {
    title: 'Санаттар',
    hideInactiveItems: 'Белсенді емес элементтерді жасыру',
    subCategoryName: 'Ішкі санат атауы',
    inactive: '(белсенді емес)',
    noSubcategories: 'Ішкі санаттар жоқ',
    selectHeader: 'Таңдау',
    actions: {
      createSubCategory: 'Жаңа ішкі санат жасау',
      restore: 'Қалпына келтіру',
      add: 'Қосу',
      addSubCategories: 'Ішкі санаттарды қосу',
      remove: 'Алып тастау',
    },
    deleteDisabledTooltip: 'Бұл санатта белсенді ішкі санаттар бар болғандықтан, оны жою мүмкін емес',
    dialogs: {
      addSubCategoriesHeader: 'Ішкі санаттарды қосу',
      deleteCategoryHeader: 'Назар аударыңыз',
      deleteCategoryMessage: 'Санатты жойғыңыз келе ме: [{{name}}]?',
      deleteSubCategoryHeader: 'Назар аударыңыз',
      deleteSubCategoryMessage: '[{{name}}] ішкі санатын [{{category}}] санатынан алып тастау керек пе? Ішкі санаттың өзі жойылмайды.',
    },
    validation: {
      subCategoryExists: 'Бұл атаумен ішкі санат бұрыннан бар',
      categoryExists: 'Бұл атаумен санат бұрыннан бар',
    },
  },
};
export default kk;
